var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.989,
    height: 17.238,
    viewBox: "0 0 19.989 17.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1382.484 -22.864)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 24.337,
    y2: 0.554,
    transform: "translate(1383.336 23.449) rotate(40)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.554,
    x2: 24.337,
    transform: "translate(1382.979 39.092) rotate(-40)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuClose);
export default __webpack_public_path__ + "static/media/mobile-menu-close.4d4ea78a4ffdbd04d5d51a9824bdf0a4.svg";
export { ForwardRef as ReactComponent };